import { antiquity } from './antiquity.schema';
import { balcony } from './balcony.schema';
import { description } from './description.schema';
import { garages } from './garages.schema';
import { laundry } from './laundry.schema';
import { price } from './price.schema';
import { rooftop } from './rooftop.schema';
import { surface } from './surface.schema';
import { yard } from './yard.schema';

const modules = {
  antiquity,
  surface,
  price,
  description,
  laundry,
  balcony,
  yard,
  rooftop,
  garages
};

export default modules;
